import * as React from "react"

const WebhooksSvg: React.FC<{ fill: string }> = ({ fill }) => (
  <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#a)">
      <path
        d="M6.5 3.5 8 2a2.829 2.829 0 0 1 4 4L9 9a2.828 2.828 0 0 1-4 0 .707.707 0 1 1 1-1 1.414 1.414 0 0 0 2 0l3-3a1.414 1.414 0 0 0-2-2l-.709.708A3.548 3.548 0 0 0 6.5 3.5Zm1 7L6 12a2.829 2.829 0 0 1-4-4l3-3a2.829 2.829 0 0 1 4 0 .707.707 0 0 1-1 1 1.414 1.414 0 0 0-2 0L3 9a1.414 1.414 0 1 0 2 2l.707-.708c.572.224 1.191.294 1.792.208Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h14v14H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default WebhooksSvg
